module.exports = __webpack_public_path__ + "img/3.7c533793.png";